export const TwofaForceReasons = {
  IS_SUPERADMIN: 1,
  MEMBER_OF_APP_THAT_FORCES_2FA: 2,
} as const;
